import * as yup from 'yup';

export const companyAddEditValidators = yup.object().shape({
  name: yup
    .string()
    .required('Пожалуйста, введите имя')
    .min(2, 'Имя должно содержать минимум 2 символа')
    .max(100, 'Имя не может содержать более 100 символов'),
  // Yup-схема статична на этапе модуля — динамически по стране лейбл
  // в текстах ошибок не подменишь без выноса схемы в фабрику. Поэтому
  // тексты сделаны нейтральными «налоговый номер» — это покрывает и
  // ИНН (RU), и БИН/ИИН (KZ). 10–12 цифр — валидно для обеих стран:
  // RU ИНН — 10 или 12, KZ БИН/ИИН — 12.
  inn: yup
    .string()
    .required('Пожалуйста, введите налоговый номер')
    .matches(/^\d+$/, 'Налоговый номер может содержать только цифры')
    .min(10, 'Налоговый номер должен содержать минимум 10 символов')
    .max(12, 'Налоговый номер не может содержать более 12 символов'),
  email: yup
    .string()
    .required('Пожалуйста, введите адрес электронной почты')
    .email('Пожалуйста, введите корректный адрес электронной почты'),
  phoneNumber: yup
    .string()
    .required('Пожалуйста, введите номер телефона')
    .matches(
      /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
      'Пожалуйста, введите корректный номер телефона'
    ),
  deliveryAddress: yup.array().of(
    yup.object().shape({
      country: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите страну'),
      region: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите регион'),
      city: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите город'),
      street: yup.string().min(2, 'Минимум 2 символа').max(150, 'Максимум 150 символов').required('Введите улицу'),
      house: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер дома'),
      apartment: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер квартиры'),
      // Индекс необязательный + без жёсткого формата: КЗ может
      // присылать буквенно-цифровые индексы; у части записей в 1С
      // индекса вообще нет, и форма из-за этого не сохранялась.
      postcode: yup.string().max(20, 'Максимум 20 символов'),
    })
  ),
  legalAddress: yup.object().shape({
    country: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите страну'),
    region: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите регион'),
    city: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите город'),
    street: yup.string().min(2, 'Минимум 2 символа').max(150, 'Максимум 150 символов').required('Введите улицу'),
    house: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер дома'),
    apartment: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер квартиры'),
    // Индекс необязательный + без жёсткого формата (см. комментарий
    // в deliveryAddress).
    postcode: yup.string().max(20, 'Максимум 20 символов'),
  }),
});

export const orderConfirmAddresSchema = yup.object().shape({
  country: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите страну'),
  region: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите регион'),
  city: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите город'),
  street: yup.string().min(2, 'Минимум 2 символа').max(150, 'Максимум 150 символов').required('Введите улицу'),
  house: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер дома'),
  apartment: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер квартиры'),
  // Индекс необязательный + без жёсткого формата (см. комментарий
  // в companyAddEditValidators).
  postcode: yup.string().max(20, 'Максимум 20 символов'),
});
